import { PicklistField } from "../blocks/fields/PicklistField";
import { LookupField } from "../blocks/fields/LookupField";
import { useLookupOptions } from "../hooks/useLookupOptions";
import { ListLookupFilterProps } from "./ListLookupFilter.types";

/** A filter that picks one of another entity's records, read when the list opens. */
export function ListLookupFilter({ filter, value, onChange }: ListLookupFilterProps) {
  const { options, loading } = useLookupOptions(filter.lookupEntity);
  const placeholder = loading ? "Loading..." : filter.placeholder ?? "Any";

  if (filter.searchable) {
    return (
      <LookupField
        label={filter.label}
        name={filter.name}
        value={value || null}
        options={options.map((option) => ({
          id: String(option.Key),
          displayName: option.Value,
        }))}
        placeholder={placeholder}
        helpText={filter.helpText}
        searchable
        onChange={onChange}
      />
    );
  }

  return (
    <PicklistField
      label={filter.label}
      name={filter.name}
      value={value}
      options={options}
      placeholder={placeholder}
      helpText={filter.helpText}
      onChange={(picked) => onChange(picked ?? "")}
    />
  );
}
